<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20">
    <g fill="none" fill-rule="evenodd">
      <g :fill="color" fill-rule="nonzero">
        <g>
          <g>
            <path
              d="M11 2.757c.686 1.07.536 1.848.17 2.689l-.145.32-.323.673C10.345 7.202 10 8.097 10 9.315c0 1.382.133 2.514.4 3.396.028.096.042.193.042.289h1.94c.379 0 .725.214.894.553l.5 1c.072.143.106.296.106.447H15c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h1.118c0-.155.036-.308.106-.447l.5-1c.169-.339.515-.553.894-.553l1.875-.001.005-.1c.007-.067.02-.133.04-.197.308-.985.462-2.114.462-3.387 0-.937-.278-1.717-.593-2.429l-.43-.935c-.46-1.03-.75-1.988.023-3.194 1.5-2.343 4.5-2.343 6 0zM15 16H1v2h14v-2zm-8.524-2.001L3.618 14l-.5 1h9.764l-.5-1H6.493l-.017-.001zm2.642-6H6.854c.1.427.146.848.146 1.316 0 1.217-.132 2.323-.4 3.317L6.493 13h2.948l-.084-.302C9.117 11.765 9 10.64 9 9.315c0-.471.039-.9.118-1.315zM5.842 3.297c-.336.524-.394.936-.242 1.485l.052.169.064.185.103.247.349.76c.142.308.265.59.37.857L9.388 7c.086-.244.186-.493.3-.75l.208-.448.271-.565c.104-.224.174-.394.223-.548.143-.442.123-.774-.137-1.234l-.096-.159c-1.107-1.728-3.21-1.728-4.316 0z"
              transform="translate(-25 -177) translate(0 128) translate(25 49)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
